module.exports = __webpack_public_path__ + "static/DisabledTripCancelled-9c71e5bbb27fc56ae7e2ea8ff534e891.png";